import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <div class=\"u-hidden\" ref=", ">\n                <div class=", ">\n                    <h1 class=", " ref=", ">", "</h1>\n                    <img class=", " src=\"", "\" ref=", " />\n                </div>\n                <div class=", " ref=", ">\n                    <div class=", ">\n                        <p>", "</p>\n\n                        <p>", "&nbsp;&nbsp;&nbsp;<a class=", " href=\"mailto:", "\" data-text=", "></a></p>\n                    </div>\n                </div>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import store from 'lib/store';
import { ref } from 'lib/lit-ref';
import anime from 'animejs';
import * as styles from './styles';
export default class About extends Component {
  init() {}

  render() {
    const {
      title,
      image,
      text,
      contact,
      email
    } = store.get('content').about;
    return html(_templateObject(), ref(this, 'wrapper'), styles.center, styles.title, ref(this, 'title'), title, styles.image, image, ref(this, 'image'), styles.centerText, ref(this, 'text'), styles.text, text, contact, styles.email, email, email);
  }

  onRender() {
    document.body.classList.add('u-loading');
    this.classList.add(styles.about);
    this.loaded = new Promise((resolve, reject) => {
      if (this.refs.image.complete) resolve();else this.refs.image.onload = () => {
        this.refs.image.onload = null;
        resolve();
      };
    });
  }

  onResize() {}

  async animateIn(params, complete) {
    await this.loaded;
    anime({
      targets: [this.refs.title, this.refs.image, this.refs.text],
      opacity: (el, i) => i == 1 ? [0, 0.5] : [0, 1],
      easing: 'easeOutCubic',
      duration: 600,
      delay: anime.stagger(100, {
        start: 100
      }),
      begin: () => {
        document.body.classList.remove('u-loading');
        this.refs.wrapper.classList.remove('u-hidden');
      },
      complete
    });
  }

  animateOut(params, complete) {
    anime({
      targets: this,
      opacity: 0,
      easing: 'easeOutCubic',
      duration: 600,
      complete
    });
  }

  onDestroy() {}

}
customElements.define('rv-about', About);